.billable-accounts-workspace { flex: 1; min-height: 0; overflow: auto; padding: 8px 10px; }
.billable-calculation-panel { margin-top: 12px; }
@media (min-width: 1281px) {
  .billable-accounts-workspace { display: flex; flex-direction: column; gap: 12px; overflow: auto; }
  .billable-account-list { flex: 1; min-height: 96px; overflow: auto; padding: 2px; }
  .billable-calculation-panel { flex: 0 1 auto; min-height: 110px; margin-top: 0; }
}

/* Relevé ouvert : résumé plus dense, sans modifier les autres vues de calcul. */
.invoice-open-panel .billable-calculation-panel { min-height: 0; margin-top: 0; }
.invoice-open-panel .billable-calculation-panel > header { gap: 4px; padding: 4px 8px; }
.invoice-open-panel .billable-calculation-panel > header h2 { font-size: 13px; line-height: 18px; }
.invoice-open-panel .billable-calculation-panel > header p { font-size: 11px; line-height: 16px; }
.invoice-open-panel .billable-calculation-panel > header p.tabular-nums:nth-child(2) { font-size: 15px; line-height: 20px; }
.invoice-open-panel .billable-calculation-panel > header button { min-height: 24px; padding: 2px 8px; font-size: 11px; }
.invoice-open-panel [aria-label="Résumé du montant"] { gap: 4px; padding: 4px 8px; }
.invoice-open-panel [aria-label="Résumé du montant"] > div { padding: 2px 6px; line-height: 16px; }
.invoice-open-panel [aria-label="Résumé du montant"] p,
.invoice-open-panel [aria-label="Résumé du montant"] p > span { font-size: 11px; }
.invoice-open-panel [aria-label="Résumé du montant"] strong { font-size: 14px; line-height: 18px; }
